import ICON_CATEGORIES from "@public/icons/iconCategories.json";
import ICON_TAGS from "@public/icons/iconTags.json";
import type { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";
import { ICONS } from "@/src/design_system/primitives/icon/constants/icons";
import {
  ICON_PICKER_CATEGORY_ID,
  type IconPickerDataCategoryId,
  type IconPickerCategoryId,
} from "@/src/design_system/form_elements/icon_picker/constants/categories";

interface FilterIconPickerIconsParams {
  selectedCategory: IconPickerCategoryId;
  searchQuery?: string;
  icons?: readonly DSIconName[];
}

type IconCategoriesMap = Partial<Record<DSIconName, readonly IconPickerDataCategoryId[]>>;
type IconTagsMap = Partial<Record<DSIconName, readonly string[]>>;

const ICON_CATEGORIES_MAP = ICON_CATEGORIES as IconCategoriesMap;
const ICON_TAGS_MAP = ICON_TAGS as IconTagsMap;

const getIconCategories = (icon: DSIconName): readonly IconPickerDataCategoryId[] => {
  return ICON_CATEGORIES_MAP[icon] ?? [];
};

const matchesCategory = (icon: DSIconName, selectedCategory: IconPickerCategoryId): boolean => {
  if (selectedCategory === ICON_PICKER_CATEGORY_ID.All) return true;

  const categories = getIconCategories(icon);

  if (selectedCategory === ICON_PICKER_CATEGORY_ID.Other) return categories.length === 0;

  return categories.includes(selectedCategory);
};

const matchesSearch = (icon: DSIconName, searchQuery: string): boolean => {
  if (!searchQuery || icon.toLowerCase().includes(searchQuery)) return true;

  const tags = ICON_TAGS_MAP[icon] ?? [];
  return tags.some(tag => tag.toLowerCase().includes(searchQuery));
};

export const filterIconPickerIcons = ({
  selectedCategory,
  searchQuery = "",
  icons = ICONS,
}: FilterIconPickerIconsParams): DSIconName[] => {
  const normalizedQuery = searchQuery.trim().toLowerCase();

  return icons.filter(icon => matchesCategory(icon, selectedCategory) && matchesSearch(icon, normalizedQuery));
};
